var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26088 8.12578H12.2399L10.183 10.1827C9.59218 10.7735 10.4784 11.6597 11.0692 11.0689L12.9425 9.1927L14.193 7.94023C14.4354 7.69642 14.4354 7.30267 14.193 7.05887L11.0692 3.93144C10.9504 3.80932 10.7868 3.74079 10.6163 3.74221C10.0537 3.74228 9.77761 4.42756 10.183 4.8177L12.2448 6.87461H1.22853C0.362035 6.9176 0.426733 8.16892 1.26088 8.12578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.c34551ed7ebe8be2946567b9384a1809.svg";
export { ForwardRef as ReactComponent };